import moment from 'moment';

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

String.prototype.toTitleCase = function () {
    return this.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
};

const format = (data, datatype, dateFormat = null) => {
    switch(datatype){
        case 'int':
            return data.toLocaleString('en-US', {maximumFractionDigits:0})
        break;
        case 'float':
            return data.toLocaleString('en-US', {maximumFractionDigits:4})
        break;
        case 'currency':
            return currencyFormatter.format(data)
        break;
        case 'string':
        case 'tag':
            return data
        break;
        case 'date':
            return moment(data).format(dateFormat ? dateFormat : 'YYYY-MM-DD');
        break;
        case 'title':
            return data.toTitleCase();
        break;
    }
}

const formatReportRows = (rows, columns, dateFormat = null) => {
    return rows.map(row => {
        var newRow = {};
        for (const [key, value] of Object.entries(row)) {
            newRow[key] = format(value, columns[key].dataType)
        }
        return newRow
    });
}

export default { format, formatReportRows };
